import { useEffect, useState } from "react";
import UserTable from "../../components/utilisateurs/UsersTable";
import UserForm from "../../components/utilisateurs/UsersForm";
import {
  getUtilisateurs,
  createUtilisateur,
  updateUtilisateur,
  deleteUtilisateur
} from "../../api/users.api";

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [userEdit, setUsersEdit] = useState(null);
  const [editData, setEditData] = useState(null);
  const [formOpen, setFormOpen] = useState(false);
const [filterRole, setFilterRole] = useState("");
const filteredUsers = users.filter((u) => {
  return filterRole ? u.role === filterRole : true;
});
  // Charger les clients
  useEffect(() => {
    loadUser();
    
  }, []);

  const loadUser = async () => {
    const res = await getUtilisateurs();
  console.log(res.data);
  
    setUsers(res.data);
      
  };
  const handleOpenAdd = () => {
    setEditData(null);
    console.log(editData);
    
    setFormOpen(true);
  };
  // 👉 appelé quand on clique sur ✏️
  const onEdit = (user) => {
    setUsersEdit(user);
    setFormOpen(true);
  };

  // 👉 appelé quand on clique sur 🗑
  const onDelete = async (id) => {
    if (window.confirm("Supprimer ce user ?")) {
      await deleteUtilisateur(id);
      loadUser();
    }
  };

  // Create ou Update
const onSubmit = async (data) => {
  if (userEdit) {
    await updateUtilisateur(userEdit.id, data);
  } else {
    await createUtilisateur(data);
  }

  setUsersEdit(null);
  setFormOpen(false); // 👈 fermer formulaire
  loadUser();
};

  return (
    <div>
      <h1>Liste des Utilisateurs</h1>
     <button onClick={handleOpenAdd} className="btn-add">
        Ajouter un utilisateur
      </button>

       <div className={`form-container ${formOpen ? "open" : ""}`}>
        {formOpen && (
     
       <UserForm onSubmit={onSubmit} user={userEdit} />
       )}
        {formOpen && (
          <button onClick={() => setFormOpen(false)} className="btn-close">
            Fermer
          </button>
        )}
        </div>
        <div className="filter-container">
        <label>Filtrer par rôle :</label>
        <select
          value={filterRole}
          onChange={(e) => setFilterRole(e.target.value)}
        >
          <option value="">-- Tous --</option>
          <option value="ADMIN">ADMIN</option>
          <option value="TECHNICIEN">TECHNICIEN</option>
        </select>
      </div>

      <UserTable
        users={filteredUsers}
        
        onEdit={onEdit}
        onDelete={onDelete}
      />
    
    </div>
  );
}
